import { BaseService } from "./baseService";
import httpRequest from "./index";
import type { Page, ReceivePayment, ReceivePaymentVo } from "@zhihaoscm/entity";

export class ReceivePaymentService extends BaseService<unknown, unknown, unknown, unknown> {
    // 支付成功
    public async paySuccess(id: string): Promise<ReceivePayment> {
        const { data } = await this.service.put(`${this.path}/pay/${id}`);
        return data;
    }

    // 收款列表
    public async customPaging(params: unknown): Promise<Page<ReceivePayment>> {
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }

    // 线下支付凭证
    public async receivePaymentOffLinePay(params: {
        id: number | string;
        fileIds: number[];
        version: number;
        paymentInstruction?: string;
    }): Promise<ReceivePaymentVo> {
        const { data } = await this.service.put(`${this.path}/offLinePay`, params);
        return data;
    }
    // 线下编辑支付凭证
    public async receivePaymentUpdatePayFile(params: {
        id: number | string;
        fileIds: number[];
        version: number;
        paymentInstruction?: string;
    }): Promise<ReceivePaymentVo> {
        const { data } = await this.service.put(`${this.path}/updatePayFile`, params);
        return data;
    }

    // 详情
    public async receivePaymentId(id: number | string): Promise<ReceivePayment> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }
}

export const receivePaymentService = new ReceivePaymentService("/receive-payment", httpRequest);
